import ManagerStore from './ManagerStore';

export * from './ManagerStore.dto';
export default new ManagerStore();
